import React, { useState } from 'react';

import {
  Container,
  BarButtonSkills,
  BarButtonWorks,
  BarButtonProjects,
  BarButtonContact,
  DropsBox1,
  DropsBox2,
  DropsBox3,
  PersonPicture,
  ResumeBoard,
  ScoreBoard,
  VisorBoard,
  IconHtml,
  IconCss,
  IconJs,
  IconPs,
  IconSolidity,
  IconTs,
  IconTw,
  IconWp,
  IconGit,
  IconPython,
  IconNode,
  IconReact,
  IconNpm,
  IconUnity,
  IconCpp,
  IconAI,
  IconRobot,
  IconOS,
  NamePerson,
  Modal,
  ButtonEnglish,
  ButtonPortuguese,
  EasterButton,
  RectangleAlert,
} from './styled.js';

export const ContentBody = () => {
  const [gBoard, setGBoard] = useState('html5');
  const [gBlue, setGBlue] = useState('ASkills');
  const [person, setPerson] = useState('person');
  const [modal, setModal] = useState('');
  const [activeModal, setActiveModal] = useState('');
  const [language, setLanguage] = useState('');
  const [easter, setEaster] = useState('');

  const handleChangeBoard = (text) => {
    setGBoard(text.target.value);
  };

  const handleChangeBlue = (text) => {
    setGBlue(text.target.value);
    setModal(text.target.value);
    switch (gBlue) {
      case 'AWorks':
        setActiveModal(true);
        break;
      case 'AProjects':
        setActiveModal(true);
        break;
      default:
        setActiveModal(false);
        break;
    }
  };

  const handleSetPerson = (text) => {
    setPerson(text.target.value);
    setGBlue(text.target.value);
  };

  const handleSetLanguage = (text) => {
    setLanguage(text.target.value);
  };

  const handleSetEaster = (text) => {
    setEaster(text.target.value);
  };

  return (
    <Container>

      <BarButtonContact
        href="https://github.com/damarquezg"
        target="_blank"
      ></BarButtonContact>

      <EasterButton onClick={handleSetEaster} value="Easter"></EasterButton>
      <NamePerson src="./images/dmg.png"></NamePerson>
      <PersonPicture src={`./images/person/` + person + `.gif`}></PersonPicture>
      <DropsBox1 onClick={handleSetPerson} value="person"></DropsBox1>
      <DropsBox2 onClick={handleSetPerson} value="personNoShirt"></DropsBox2>
      <DropsBox3 onClick={handleSetPerson} value="personNoPants"></DropsBox3>
      <ResumeBoard src="./images/QuadroResumo.png"></ResumeBoard>
      <IconCss onClick={handleChangeBoard} value="git"></IconCss>
      <IconJs onClick={handleChangeBoard} value="git"></IconJs>
      <IconPs onClick={handleChangeBoard} value="git"></IconPs>
      <IconSolidity onClick={handleChangeBoard} value="git"></IconSolidity>
      <IconTs onClick={handleChangeBoard} value="git"></IconTs>
      <IconTw onClick={handleChangeBoard} value="git"></IconTw>
      <IconWp onClick={handleChangeBoard} value="git"></IconWp>
      <IconHtml onClick={handleChangeBoard} value="git"></IconHtml>
      <IconOS onClick={handleChangeBoard} value="git"></IconOS>
      <IconPython onClick={handleChangeBoard} value="python"></IconPython>
      <IconCpp onClick={handleChangeBoard} value="cpp"></IconCpp>
      <IconAI onClick={handleChangeBoard} value="aiml"></IconAI>
      <IconRobot onClick={handleChangeBoard} value="aiml"></IconRobot>
      <ScoreBoard
        src={`./images/wpEn.png`}
      ></ScoreBoard>
      <VisorBoard
        src={`./images/QuadroVisorComplete.png`}
      ></VisorBoard>

      <Modal
        style={{
          display: activeModal ? 'block' : 'none',
        }}
        src={`./images/modal/` + modal + language + `.png`}
      ></Modal>
    </Container>
  );
};
